'use strict'
exports.__esModule = true
exports.default = copyTextToClipboard

var _is = require('../is')

function copyTextToClipboard(text) {
  var textarea = document.createElement('textarea')
  textarea.innerHTML = text

  // styles
  textarea.style.position = 'absolute'
  textarea.style.top = '-9999px'
  textarea.style.left = '-9999px'
  if ((0, _is.isNull)(document.body)) return
  var _document = document,
    body = _document.body

  // copying
  body.appendChild(textarea)

  // save original selection
  var selected = null
  var selection = document.getSelection()
  if (!(0, _is.isNull)(selection) && selection.rangeCount > 0) {
    selected = selection.getRangeAt(0)
  }

  textarea.select()
  document.execCommand('copy')
  body.removeChild(textarea)

  selection = document.getSelection()
  if (!(0, _is.isNull)(selected) && !(0, _is.isNull)(selection)) {
    // If a selection existed before copying
    selection.removeAllRanges() // Unselect everything on the HTML document
    selection.addRange(selected) // Restore the original selection
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/misc/copyToClipboard.js
// module id = 639
// module chunks = 0